import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ColorAdjuster } from '@keen.io/ui-core';
import { ChartContext } from '../../../../contexts';
export var createTextMotion = function (x, y) { return ({
    initial: { opacity: 0, x: x, y: y },
    animate: {
        opacity: 1,
        x: x,
        y: y,
    },
    transition: { duration: 0.4 },
    exit: {},
}); };
var BarValues = function (_a) {
    var bars = _a.bars, autocolor = _a.autocolor;
    var bar = useContext(ChartContext).theme.bar;
    var _b = bar.values.typography, fontColor = _b.fontColor, typography = __rest(_b, ["fontColor"]);
    var textProps = {
        pointerEvents: 'none',
        textAnchor: 'middle',
        dominantBaseline: 'middle',
        style: typography,
    };
    return (React.createElement(React.Fragment, null, bars.map(function (_a) {
        var key = _a.key, x = _a.x, y = _a.y, width = _a.width, height = _a.height, value = _a.value, color = _a.color;
        var textMotion = createTextMotion(x + width / 2, y + height / 2);
        return autocolor ? (React.createElement(ColorAdjuster, { key: key, baseColor: color }, function (adjustedColor) { return (React.createElement(motion.text, __assign({ key: key, fill: adjustedColor }, textProps, textMotion), value)); })) : (React.createElement(motion.text, __assign({ fill: fontColor, key: key }, textProps, textMotion), value));
    })));
};
export default BarValues;
